import global from '@/common/global';
export default (Vue) => {
    /**
     * sticky 用于元素吸顶
     * @params { class } 当元素原位置顶部到达视口顶部时,追加的class,反之,去掉这个class.
     * eg: v-sticky={class:'fixed'} .fixed{position:fixed;top:0;left:0;}
     * 元素原位置的顶部到达视口顶部时，元素就会吸顶，反之，元素就回到原来位置
     */
    Vue.directive('sticky', {
        inserted(el, binding) {
            if (binding.value) {
                let cls = binding.value.class;
                // 留一个站位的，用于判断原元素的位置是否超出视口
                var holder = document.createElement('div');
                holder.style.height = `0px`;
                holder.style.border = 'none';
                el.before(holder);
                el.holder = holder;
                let initClassName = el.className; // 保存原元素的样式
                el.__vueScrollVisible__ = function () {
                    // 如果元素已经吸顶 则根据站位元素判断是否超出视口
                    let elem = el.isSticky ? el.holder : el,
                        res = elem.getBoundingClientRect();
                    try {
                        // 元素顶部到达视口顶部
                        if (res.top <= 0) {
                            el.holder.style.paddingTop = el.offsetHeight + 'px';
                            el.holder.className = initClassName;
                            el.classList.add(cls);
                            el.isSticky = true;
                        } else {
                            el.holder.style.paddingTop = '0px';
                            el.holder.className = '';
                            el.classList.remove(cls);
                            el.isSticky = false;
                        }
                    } catch (e) {}
                };
                global.scroll(el.__vueScrollVisible__);
            }
        },
        unbind(el, binding) {
            if (binding.value) {
                global.scroll(el.__vueScrollVisible__, true);
                delete el.__vueScrollVisible__;
            }
        }
    });
};
